const swipe = (container, direction, timeout) => new Promise((resolve, reject) => {

	let dir;
	let opposite;

	switch (direction) {
		case 'left':
			dir = 'translateX(-100%)';
			opposite = 'translateX(100%)';
			break;
		case 'right':
			dir = 'translateX(100%)';
			opposite = 'translateX(-100%)';
			break;
		case 'up':
			dir = 'translateY(100%)';
			opposite = 'translateY(-100%)';
			break;
		case 'down':
			dir = 'translateY(-100%)';
			opposite = 'translateY(100%)';
			break;
	}

	setTimeout(() => {
		return resolve(true);
	}, timeout);

	//Add transition effect and swipe 1 screen away to left
	container.style.transition = 'all 0.5s ease';
	container.style.opacity = '0';
	container.style.transform = dir;

	//Remove transition effect and go 1 screen in opposite direction
	setTimeout(() => {
		container.style.transition = '';
		container.style.transform = opposite;
	}, 400);

	// Turn on transition again and let it flow back
	setTimeout(() => {
		container.style.opacity = '1';
		container.style.transition = 'all 0.5s ease';
		container.style.transform = '';
	}, 600);
});

const fade = (container, direction, duration) => new Promise(resolve => {
	let opacity = direction === 'out' ? 0 : 1;
	const _transition = container.style.transition;

	// TODO: transitionend event ?
	setTimeout(() => {
		// Reset transition
		container.style.transition = _transition;
		resolve(true);
	}, duration + 100);

	container.style.transition = `opacity ${duration}ms`;
	container.style.opacity = opacity;
});


const animation = async (container, direction, timeout) => {
	return await swipe(container, direction, timeout);
};


export { swipe, animation, fade };